import React, { useMemo } from 'react';
import { Col, Row } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import {
  CurrencyField,
  DataTable,
  DateTimeField,
  Field,
} from '../../../commons/DataTable';
import { ContAffiliation, H5Styled } from '../../../styled-components';
import TotalRow from './TotalRow';
import FieldIafNumber from '../../../commons/DataTable/FieldIafNumber';

function IafsTable({ title, iafs = [], anchorId }) {
  const [t] = useTranslation();
  const total = useMemo(
    () => iafs.reduce((acc, elem) => acc + (elem.amount || 0), 0),
    [iafs]
  );
  const totalServices = useMemo(
    () => iafs.reduce((acc, elem) => acc + (elem.totalServices || 0), 0),
    [iafs]
  );

  return (
    <ContAffiliation id={anchorId}>
      <Row>
        <Col xs="12">
          <H5Styled>{title}</H5Styled>
        </Col>
      </Row>
      <DataTable
        data={iafs}
        total={iafs.length}
        offset={0}
        limit={iafs.length || 1}
        onFilter={() => {}}
        emptyText={t('COMMON:NO_DATA')}
        tableFixed
        bottomRow={<TotalRow total={total} totalServices={totalServices} />}
      >
        <FieldIafNumber
          title="Numero IAF"
          source="number"
          className="text-left"
        />
        <Field title="Rif. Fattura" source="invoiceRef" />
        <Field
          title={t('ROYALTY:IAF_ACCOUNTABILITY')}
          source="accountability"
        />
        <DateTimeField title="Data" source="date" format="DD/MM/YYYY" />
        <CurrencyField title="Importo IAF" source="amount" />
        <CurrencyField title="Totale Servizi" source="totalServices" />
      </DataTable>
    </ContAffiliation>
  );
}

export default IafsTable;
